import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FuseLoadingBarModule } from '@fuse/components/loading-bar';
import { SharedModule } from 'app/shared/shared.module';
import { LandingLayoutComponent } from './landing.component';
import { HeaderUserComponent } from './components/header-user.component';

@NgModule({
  declarations: [
    LandingLayoutComponent,
    HeaderUserComponent
  ],
  imports: [RouterModule, FuseLoadingBarModule, SharedModule],
  exports: [
    LandingLayoutComponent,
    HeaderUserComponent
  ],
})
export class LandingLayoutModule {}
